import * as React from 'react';
import { isPanelView } from './utils';
import { LinkHelper } from '../routes';
import NavBar from './NavBar';
const styles = require('./mainLayout.less') as any;
const Logo = require('../../assets/logo.png') as any;

//<LinkHelper to="home">Logout</LinkHelper>
//<img className={styles.Logo} src="https://dev.accessplace.org/images/logo-flopped.png" />

const Header = ({active_routes, isAuthenticated, profileCompleted, showSubtitle, showNav}) => (
    <header className={styles.header}>
        <Banner showSubtitle={showSubtitle} />
        {showNav &&
				 <NavBar {...{isAuthenticated}} active_routes={active_routes} profileCompleted={profileCompleted} position="header" />}
    </header>
);

const Banner = ({showSubtitle}) => (
    <div className={styles.Banner}>
        <LinkHelper to='home' className={styles.HomeLink}>
            <img className={styles.Logo} src={Logo} />
            <section className={styles.Header}>
                <h1 className={styles.Title}>AccessPlace</h1>
                {showSubtitle && <span className={styles.subtitle}>Personalized accessibility information</span>}
            </section>
        </LinkHelper>
    </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/app/Layouts/Header.tsx